import { render, staticRenderFns } from "./alterCustomer.vue?vue&type=template&id=73e517a4&scoped=true&"
import script from "./alterCustomer.vue?vue&type=script&lang=js&"
export * from "./alterCustomer.vue?vue&type=script&lang=js&"
import style0 from "./alterCustomer.vue?vue&type=style&index=0&id=73e517a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e517a4",
  null
  
)

export default component.exports